import { useQuery } from "@tanstack/react-query";
import {
  CreateDiscountInput,
  DeleteDiscountInput,
  GetQueryProps,
  UpdateDiscountInput,
} from "shared";
import { axiosClient } from "utilz";
import {
  apiErrorHandler,
  generateUrlString,
  getQueryDataObject,
} from "utilz/helpers";

export const getAllDiscounts = async ({
  perPageCount,
  pageNumber,
  sortColumn,
  sortDirection,
  filter,
  searchQuery,
}: GetQueryProps) => {
  try {
    const data = await getQueryDataObject({
      perPageCount,
      pageNumber,
      sortColumn,
      sortDirection,
      filter,
      searchQuery,
    });
    const url = await generateUrlString({
      baseUrl: "/v1/configuration/billing/discounts",
      data,
    });
    const response = await axiosClient.get(url);

    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const createDiscount = async (data: CreateDiscountInput) => {
  try {
    const url = "/v1/configuration/billing/discounts";
    const response = await axiosClient.post(url, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateDiscount = async ({
  discount_id,
  ...data
}: UpdateDiscountInput) => {
  try {
    const url = `/v1/configuration/billing/discounts/${discount_id}`;
    const response = await axiosClient.patch(url, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const deleteDiscount = async (data: DeleteDiscountInput) => {
  try {
    const url = "/v1/configuration/billing/discounts";
    const response = await axiosClient.put(url, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
